import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { GetUser } from '../../../apps/checkout/src/client/graphql/queries';
import useIdToken from './use-id-token';

const useQueryFallback = () => undefined; // TODO: remove duplicate logic at apps/checkout/src/client/lib/use-get-user.ts


export function useUser(useQuery = useQueryFallback, includeAuthHeader = true) {
  var _result$data;

  const {
    idToken
  } = useIdToken();
  let context = {
    version: 2
  };

  if (includeAuthHeader) {
    context = _objectSpread(_objectSpread({}, context), {}, {
      headers: {
        Authorization: "Bearer ".concat(idToken)
      }
    });
  }

  const result = useQuery(GetUser, {
    context,
    skip: false || !idToken,
    errorPolicy: 'ignore',
    fetchPolicy: 'network-only'
  });
  return {
    user: result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.currentUser
  };
}